<template>
  <div>
    <div
      class="main-content"
      :class="locale == 'en' ? 'main-content-en' : 'main-content-ar'"
    >
      <v-container style="padding-top: 0; padding-bottom: 0;">
        <v-col
          cols="12"
          sm="10"
          offset-sm="1"
          style="padding-top: 0; padding-bottom: 0;"
        >
        </v-col>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "comingSoon",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/_variables.scss";

.main-content {
  min-height: 91vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: scroll !important;
  position: relative;
  //   padding-top: $padding-top;
}

.main-content-en {
  background-image: url("../assets/images/comingsoon-en.png");
}
.main-content-ar {
  background-image: url("../assets/images/comingsoon-ar.png");
}

label {
  color: #ffffff;
}
</style>
